import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Broadcast, Calendar, FilmStrip, User, Users, EnvelopeSimple } from "@phosphor-icons/react";
import { Hero } from "../components/Hero";
import { MarqueeBar } from "../components/MarqueeBar";
import { DiscordCTA } from "../components/DiscordCTA";

const navCards = [
    { to: "/live", label: "Live", icon: Broadcast, desc: "Tune in to the stream + chat." },
    { to: "/schedule", label: "Schedule", icon: Calendar, desc: "Every day around 11 AM EST." },
    { to: "/clips", label: "Clips", icon: FilmStrip, desc: "The chaos, distilled." },
    { to: "/about", label: "About", icon: User, desc: "From ooll56 to itz_ool." },
    { to: "/community", label: "Community", icon: Users, desc: "Meet the mod crew." },
    { to: "/contact", label: "Contact", icon: EnvelopeSimple, desc: "Collabs · Business · Press." },
];

export const HomePage = () => {
    return (
        <div data-testid="home-page">
            <Hero />
            <MarqueeBar />

            <section className="relative py-16 lg:py-24" data-testid="home-explore">
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="mb-10 max-w-2xl"
                    >
                        <span className="eyebrow">Explore</span>
                        <h2 className="font-display text-3xl sm:text-4xl text-white mt-2 leading-tight">
                            Every corner of the <span className="gradient-text">channel.</span>
                        </h2>
                    </motion.div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        {navCards.map((c, i) => (
                            <motion.div
                                key={c.to}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.05 }}
                            >
                                <Link
                                    to={c.to}
                                    className="block relative rounded-2xl border border-white/10 bg-obsidian-900/60 p-6 card-tilt group h-full"
                                    data-testid={`home-portal-${c.label.toLowerCase()}`}
                                >
                                    <div className="flex items-center justify-between mb-8">
                                        <div className="h-11 w-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                                            <c.icon size={18} className="text-brand-cyan" weight="fill" />
                                        </div>
                                        <span className="text-[10px] uppercase tracking-[0.25em] text-white/25 font-mono">0{i + 1}</span>
                                    </div>
                                    <div className="font-display text-xl text-white mb-2">{c.label}</div>
                                    <div className="text-sm text-white/55 mb-5">{c.desc}</div>
                                    <div className="flex items-center gap-1.5 text-brand-cyan text-xs font-medium group-hover:gap-2.5 transition-all uppercase tracking-wider">
                                        Open <ArrowRight size={12} weight="bold" />
                                    </div>
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <DiscordCTA />
        </div>
    );
};
